import { Components, PaletteMode, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';

declare module '@mui/material/LinearProgress' {
  interface LinearProgressPropsColorOverrides {
    primary: true;
    secondary: true;
    error: true;
    info: true;
    success: true;
    warning: true;
  }
}

export const MuiLinearProgressTheme = (
  mode: PaletteMode,
): Components<Theme>['MuiLinearProgress'] => {
  const { componentTokens, tokens } = themePalette(mode);

  return {
    defaultProps: {
      color: 'primary',
    },
    styleOverrides: {
      root: {
        height: '5px',
        borderRadius: '9999px', // pill shape
        backgroundColor: tokens.content.assets.neutral[5],
      },
      bar: {
        borderRadius: '9999px',
        transition:
          'width 100ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, background-color 100ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
      },
    },
    variants: [
      {
        props: { color: 'primary' },
        style: {
          '& .MuiLinearProgress-bar': {
            backgroundColor: componentTokens.badges.colors.solid.brand.background.standard,
          },
        },
      },
      {
        props: { color: 'secondary' },
        style: {
          '& .MuiLinearProgress-bar': {
            backgroundColor: componentTokens.badges.colors.subtle.info.background.standard,
          },
        },
      },
      {
        props: { color: 'error' },
        style: {
          '& .MuiLinearProgress-bar': {
            backgroundColor: componentTokens.badges.colors.solid.error.background.standard,
          },
        },
      },
      {
        props: { color: 'info' },
        style: {
          '& .MuiLinearProgress-bar': {
            backgroundColor: componentTokens.badges.colors.solid.info.background.standard,
          },
        },
      },
      {
        props: { color: 'success' },
        style: {
          '& .MuiLinearProgress-bar': {
            backgroundColor: componentTokens.badges.colors.solid.success.background.standard,
          },
        },
      },
      {
        props: { color: 'warning' },
        style: {
          '& .MuiLinearProgress-bar': {
            backgroundColor: componentTokens.badges.colors.solid.warning.background.standard,
          },
        },
      },
    ],
  };
};
